/**
 * Money helpers. Statement amounts are stored as double precision; to avoid
 * floating-point drift when summing many lines per member, always round to
 * cents at aggregation boundaries with `roundMoney`. `toCents` gives an exact
 * integer for billing math.
 */

/** Round a dollar amount to whole cents (kills float drift in sums). */
export function roundMoney(n: number): number {
  return Math.round((n + Number.EPSILON) * 100) / 100;
}

/** Exact integer cents for a dollar amount (billing). */
export function toCents(n: number): number {
  return Math.round((n + Number.EPSILON) * 100);
}

/** Format a dollar amount as USD. */
export function formatUsd(n: number): string {
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}
